const utmList = ['Direct', 'Seo', 'Yahoo', 'Google', 'Facebook', 'Instagram'];
const cookies = ['utm', 'gcl', 'ref', 'g', 'l', 'p', 'mid', 'cam'];

function queryToArray() {
    const vars = {};
    const hash = window.location.search.slice(1).split('&');

    for (let i = 0; i < hash.length; i++) {
        const data = hash[i].split('=');
        vars[data[0]] = data[1];
    }
    return vars;
}

function setCookie(name, value) {
    document.cookie = name + '=' + encodeURIComponent(value) + ';path=/; max-age=2592000;';
}

function isCookie(name) {
    return document.cookie.indexOf(name) !== -1;
}

function getCookie(name) {
    const item = document.cookie.split(';');
    let text = '';

    for (let i = 0; i < item.length; i++) {
        const elem = item[i].split('=');
        if (elem[0].trim() === name) {
            text = decodeURIComponent(elem[1]);
        }
    }
    return text;
}

function createHiddenInput(name, value) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    return input;
}

/**
 * LPフォームにcookieとtempFromをhiddenで付与
 */
export function initLpForms() {
    setTimeout(() => {
        const forms = Array.prototype.slice.call(document.querySelectorAll('form'), 0);
        forms.forEach((element) => {
            cookies.forEach((name) => {
                element.appendChild(createHiddenInput(name, getCookie(name)));
            });
            element.appendChild(createHiddenInput('tempFrom', location.pathname));
        });
    });
}

/**
 * 共通トラッキング（UTM / gclid / referrer）
 * 読み込むだけで実行
 */
function initGeneralTracking() {
    const query = queryToArray();

    if (query['utm_source'] != null) {
        setCookie('utm', query['utm_source']);
    }
    if (query['utm_medium'] != null) {
        setCookie('mid', query['utm_medium']);
    }
    if (query['utm_campaign'] != null) {
        setCookie('cam', query['utm_campaign']);
    }

    if (!isCookie('utm')) {
        if (document.referrer.length > 0) {
            if (document.referrer.indexOf('yahoo') || document.referrer.indexOf('google')) {
                setCookie('utm', utmList[1]);
            }
        }
        if (!isCookie('utm')) {
            setCookie('utm', utmList[0]);
        }
    }

    if (query['gclid'] != null) {
        setCookie('gcl', query['gclid']);
    }

    if (!isCookie('ref') && document.referrer.length > 0) {
        setCookie('ref', document.referrer);
    }
}

initGeneralTracking();
